<template>
  <div class="page-layout">
    <ApiEventsFilters
        :table-model="tableModel"
    />
    <ApiEventsGrid
        :on-get-details="handleGetDetails"
        :on-update-page="handleUpdatePage"
        :on-update-items-per-page="handleUpdateItemsPerPage"
        :table-model="tableModel"
        :page-sizes-list="pageSizesList"
    />
  </div>
</template>

<script>
import { reactive } from 'vue';
import api from '@/api';
import RemoteTableModel from '@/components/RemoteTableModel';
import LogInfoWindow from "../../../components/LogInfo.vue";
import ApiEventsFilters from "./Filters.vue";
import ApiEventsGrid from "./Grid.vue";
import { toast } from '@/lib/toast';
import { useApiEventsLogComponentStore } from '@/stores/apiEventsLogComponentStore.js';

export default {
  name: 'ApiEvents',
  components: {ApiEventsFilters, ApiEventsGrid, LogInfoWindow},
  setup() {
    const pageSizesList = [
      {title: '15', value: 15},
      {title: '50', value: 50},
      {title: '100', value: 100},
      {title: '500', value: 500},
    ];

    const { getColumnsHeaders } = useApiEventsLogComponentStore();

    const tableModel = reactive(
        new RemoteTableModel({
          headers: getColumnsHeaders(),
          loader(query) {
            const queryParams = {
              ...query.searchParams,
              ...query.range,
            };

            if (query.sort && query.sort.length > 0) {
              query.sort.forEach(({ column, order }) => {
                queryParams[`order[${column}]`] = order.toLowerCase();
              });
            }

            return api.get('/api/api_log', queryParams);
          },
          options: {
            sortBy: [
              {key: 'event.createdAt', order: 'desc' }
            ],
            isApiRequest: true,
            itemsPerPage: 15,
          },
        }),
    );

    const reload = () => {
      tableModel.reload();
    };

    const handleGetDetails = async (fileId) => {
      try {
        await api.get(`/admin/checkFile/${fileId}`);
        window.location.href = `admin/downloadFile/${fileId}`;
      } catch(e) {
        toast.error('Файл был удалён или перемещён. Его просмотр недоступен.')
      }
    };

    const handleUpdateItemsPerPage = (value) => {
      tableModel.bind.itemsPerPage = parseInt(value, 10);
      tableModel.bind.options.itemsPerPage = parseInt(value, 10);
      tableModel.bind.options.page = 1;
      reload();
    };

    const handleUpdatePage = (value) => {
      tableModel.bind.options.page = parseInt(value, 10);
      reload();
    };

    return {
      pageSizesList,
      tableModel,
      handleGetDetails,
      handleUpdateItemsPerPage,
      handleUpdatePage,
    };
  },
};
</script>

<style scoped>
.page-layout {
  margin: 0 88px 0 64px;
  min-width: 1079px;
}
</style>
